import BaseModel from './BaseModel'
import CountryRegion from './CountryRegion'

export default class RegionDistrict extends BaseModel {
  public id: string = ''
  public name: string = ''
  public geoCode: string = ''
  public region: CountryRegion = null
}
